module.exports = __webpack_public_path__ + "img/team-mosaic-02.3bfbd5ff.jpg";